"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const search_svg_1 = __importDefault(require("../../icons/search.svg"));
exports.default = react_1.default.memo(SearchBox);
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        backgroundColor: theme.colors.sidePanel.subHeaderBackgroundColor,
        padding: "6px 15px",
        position: "relative"
    },
    textBox: {
        width: "100%",
        border: 0,
        borderRadius: 25,
        padding: "4px 15px 6px 64px",
        fontSize: 15,
        fontWeight: 300,
        outline: "none",
        color: theme.colors.textBox.textColor,
        backgroundColor: theme.colors.textBox.backgroundColor
    },
    icon: {
        display: "block",
        float: "left",
        position: "absolute",
        top: 11,
        left: 25,
        color: "#aaaaaa"
    }
}));
function SearchBox(props) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement("input", { className: classes.textBox, ref: props.ref, maxLength: 25, value: props.text, onChange: e => props.onChange(e.target.value), placeholder: props.placeholderText }),
        react_1.default.createElement(search_svg_1.default, { className: classes.icon })));
}
